<div class="side-header-toggle">

      <button (click)="toggleSideHeader()" class="side-header-close"><i class="fa fa-close"></i></button>
      <div class="side-header-inner custom-scroll" >
            <nav class="side-menu-item" id="side-header-menu">
                  <ul>
                        <li class="has-sub-menu" routerLinkActive="active"><a routerLink="/menu/home"><i
                                          class="fa fa-home"></i>
                                    <span>Home</span></a></li>
                        <li class="has-sub-menu" routerLinkActive="active"><a
                                    routerLink="/menu/ricerca-avanzata"><i class="fa fa-search"></i> <span>Ricerca
                                          Avanzata</span></a></li>
                        <li class="has-sub-menu" routerLinkActive="active">
                          <a routerLink="/menu/portafogli">
                            <i class="fa fa-money"></i>
                            <span> Portafoglio </span>
                          </a>
                        </li>
                        <li class="has-sub-menu" routerLinkActive="active">
                          <a routerLink="/menu/watchlists">
                            <i class="fa fa-eye"></i>
                            <span> Watchlist </span>
                          </a>
                        </li>
                        <li class="has-sub-menu" routerLinkActive="active" *ngIf="userHasProfessionalRole() || userIsAdmin()">
                              <a routerLink="/menu/merge-tool">
                                    <i class="fa fa-random"></i> <span>Strumento merge</span>
                              </a>
                        </li>

                        <li class="has-sub-menu" routerLinkActive="active"><a routerLink="/menu/sottostante"><i
                                          class="fa fa-arrow-down"></i> <span>Sottostante</span></a></li>
                        <li class="has-sub-menu" routerLinkActive="active"><a routerLink="/menu/matrice"><i
                                          class="fa fa-table"></i>
                                    <span>Matrice</span></a></li>
                        <li routerLinkActive="active"><a routerLink="/menu/viewall/notifications"><i class="fa fa-bell"
                                          aria-hidden="true"></i> <span>Bacheca Avvisi</span></a></li>
                        <li class="has-sub-menu" routerLinkActive="active"><a routerLink="/menu/calendario-eventi"><i
                                          class="fa fa-calendar"></i> <span>Calendario Eventi</span></a></li>
                        <li class="has-sub-menu" routerLinkActive="active"><a routerLink="/menu/acquista-servizi"><i
                                          class="fa fa-shopping-cart"></i> <span>Acquista Servizi</span></a></li>
                        <ng-container *ngIf="userIsAdmin()">
                          <li  id="admin-menu-title-li" class="my-3 has-sub-menu"
                               style="text-align: center; font-size: medium;">Admin menu</li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/prezzoCertificato"><i class="fa fa-dollar" aria-hidden="true"></i>
                            <span>Gestione Prezzo</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active">
                            <a routerLink="/menu/gestione/info-cedola">
                              <i class="fa fa-dollar" aria-hidden="true"></i>
                              <span>Gestione Info Cedole</span>
                            </a>
                          </li>

                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/news"><i class="fa fa-print" aria-hidden="true"></i>
                            <span>Gestione News</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/eventi"><i class="fa fa-ticket" aria-hidden="true"></i>
                            <span>Gestione Eventi</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/info"><i class="fa fa-info-circle"
                                                                aria-hidden="true"></i> <span>Gestione Info</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/privacy"><i class="fa fa-lock" aria-hidden="true"></i>
                            <span>Gestione Privacy</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/prodotti"><i class="fa fa-cubes" aria-hidden="true"></i>
                            <span>Gestione
                                          Prodotti</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active">
                            <a routerLink="/menu/gestione/utenti">
                              <i class="fa fa-users" aria-hidden="true"></i>
                              <span>Gestione Utenti</span>
                            </a>
                          </li>
                          <li class="has-sub-menu" routerLinkActive="active"><a
                            routerLink="/menu/gestione/ordini"><i class="fa fa-spinner" aria-hidden="true"></i>
                            <span>Gestione Ordini</span></a></li>
                          <li class="has-sub-menu" routerLinkActive="active">
                            <a routerLink="/menu/gestione/diagnostica">
                              <i class="fa fa-exclamation" aria-hidden="true"></i>
                              <span>Diagnostica</span>
                            </a>
                          </li>
                        </ng-container>
                  </ul>
            </nav>
      </div>
</div>
